/**
 * Specifies the type of prescription for a pharmacy order.
 */
export enum PharmacyOrderPrescriptionType {
    /**
     * The prescription is for a full order.
     */
    Full,

    /**
     * The prescription is for a partial order.
     */
    Partial,

    /**
     * The prescription is empty.
     */
    Empty
}
